import { render, staticRenderFns } from "./ItemBadgeList.vue?vue&type=template&id=bc1ca126&"
import script from "./ItemBadgeList.vue?vue&type=script&lang=ts&"
export * from "./ItemBadgeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports